import React from 'react'; 
import PropTypes from 'prop-types';
import * as moment from 'moment';
import 'moment/locale/ru';


const HomeCardTemplate = props => (
    <li className="card" key={props.title}>
        <a href={props.href} target="_blank" className="card__link">
            <h4 className="card__text_title">{props.title}</h4>
            <span className="article__info">
                <time className="card__text_date">
                    <svg dangerouslySetInnerHTML={{ __html: '<use xlink:href="#icon-clock-card" ></use>' }} />
                    {moment(props.publishTime.sec * 1000).format('D MMMM YYYY г., H:mm')}
                </time>
            </span>
        </a>
    </li>
);


HomeCardTemplate.propTypes = {
    href: PropTypes.string.isRequired,
    publishTime: PropTypes.instanceOf(Object).isRequired,
    title: PropTypes.string.isRequired
};


HomeCardTemplate.defaultProps = {
    authors: []
};

const HomeCardSmall = props => (
    <ul className="home__card home__card_small">{
        props.data.map(item => (<HomeCardTemplate key={`item_main_small_${item.href}`} {...item} />))
    }</ul>
);

HomeCardSmall.propTypes = {
    data: PropTypes.arrayOf(PropTypes.object)
};

HomeCardSmall.defaultProps = { 
    data: null
};

export default HomeCardSmall;



// WEBPACK FOOTER //
// ./src/components/HomeCardSmall.jsx